class QueryStringManipulator {
    static updateQueryStringParameter(uri: string, key: string, value: string) {
        const re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
        const separator = uri.indexOf('?') !== -1 ? '&' : '?';
        if (uri.match(re)) {
            return uri.replace(re, '$1' + key + '=' + value + '$2');
        } else {
            return uri + separator + key + '=' + value;
        }
    }

    static removeQueryStringParameter(uri: string, key: string) {
        const [pathAndQuery, hash = ''] = uri.split('#');
        const qIndex = pathAndQuery.indexOf('?');
        if (qIndex === -1) return uri;

        const base = pathAndQuery.slice(0, qIndex);
        const query = pathAndQuery.slice(qIndex + 1);

        const params = new URLSearchParams(query);
        params.delete(key);

        const qs = params.toString();
        const newUri = qs ? `${base}?${qs}` : base;
        return hash ? `${newUri}#${hash}` : newUri;
    }
}

export default QueryStringManipulator;
